import { render, staticRenderFns } from "./plan-table.vue?vue&type=template&id=2355d7f6"
import script from "./plan-table.vue?vue&type=script&lang=js"
export * from "./plan-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports